import { apiSlice } from '../../api/apiSlice';
import {
 
    DISPUTE_SCORECARD_CREATE
} from '../../constants';

export const DisputeSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
         createScorecardDispute: builder.mutation({
            query: (arg: any) => ({
                url: DISPUTE_SCORECARD_CREATE,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Disputes'],
        }),
    }),
});

export const {
    useCreateScorecardDisputeMutation
} = DisputeSlice;
